import { useState } from "react";
import axios from "axios";
import { bannerData } from "../../../globals/banner";
import Banner from "../../sections/common/banner";

function ContactUsPage() {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    phone: '',
    subject: 'Contact Form Submission',
    message: '',
    website: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [errors, setErrors] = useState({});
  const [formCreatedAt, setFormCreatedAt] = useState(Date.now());
  const [hasSubmittedOnce, setHasSubmittedOnce] = useState(false);

  // ✅ Add this function here
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  // ✅ End of new addition

  const validateForm = () => {
    const newErrors = {};
    if (!formData.username.trim()) newErrors.username = 'Name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
    if (!formData.message.trim()) newErrors.message = 'Message is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const elapsedMs = Date.now() - formCreatedAt;
    const isHoneypotTripped = !!formData.website?.trim();

    if (isHoneypotTripped || (!hasSubmittedOnce && elapsedMs < 3000)) {
      setSubmitStatus({ type: 'success', message: 'Thank you! Your message has been received.' });
      setFormData({
        username: '',
        email: '',
        phone: '',
        subject: 'Contact Form Submission',
        message: '',
        website: ''
      });
      setErrors({});
      setFormCreatedAt(Date.now());
      if (!hasSubmittedOnce) setHasSubmittedOnce(true);
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await axios.post(
        'https://mailer.infotraceanalytics.com/sendmail.php',
        {
          username: formData.username,
          email: formData.email,
          phone: formData.phone,
          subject: formData.subject,
          message: formData.message,
        },
        {
          headers: { 'Content-Type': 'application/json' },
          timeout: 15000
        }
      );

      const result = response.data;

      if (result.success) {
        setSubmitStatus({ type: 'success', message: result.message });
        setFormData({
          username: '',
          email: '',
          phone: '',
          subject: 'Contact Form Submission',
          message: '',
          website: ''
        });
        setErrors({});
        setFormCreatedAt(Date.now());
      } else {
        setSubmitStatus({ type: 'error', message: result.message || 'Failed to send message' });
      }
    } catch (error) {
      let errorMessage = 'An error occurred while sending your message.';

      if (error.isAxiosError && error.response?.status === 404) {
        errorMessage = 'Service temporarily unavailable. Please try again later.';
      } else if (error.isAxiosError && error.response?.status === 500) {
        errorMessage = 'Server error. Please try again later.';
      } else if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
        errorMessage = 'Request timed out. Please try again.';
      } else if (!navigator.onLine) {
        errorMessage = 'Network error. Please check your internet connection and try again.';
      }

      setSubmitStatus({ type: 'error', message: errorMessage });
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <>
      <Banner _data={bannerData.contact} />

      {/* Contact us START */}
      <div className="section-full p-t110 p-b80 sx-bg-white sx-ourteam-outer ">
        <div className="container">
          <div className="section-content">
            <div className="row justify-content-center">
              {/* Contact Info */}
              <div className="col-lg-8 col-md-12 m-b30">
                <div className="contact-info">
                  <div className="section-head left">
                    <div className="sx-head-s-title">Contact Us</div>
                    <div className="sx-head-l-title">
                      <h2 className="sx-title">Let Us Know About Your Opinion!</h2>
                    </div>
                  </div>
                  <div className="row sx-contact-form-icon-bx">
                    <div className="col-lg-6 col-md-6 m-b30">
                      <div className="sx-icon-bx-5">
                        <div className="sx-media">
                          <i className="flaticon-telephone" />
                        </div>
                        <div className="sx-icon-bx-info">
                          <span className="sx-icon-bx-title-info">Contact Phone</span>
                          <a href="tel:+254797435680" className="sx-icon-bx-title">
                            + (254) 797 435 680
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 m-b30">
                      <div className="sx-icon-bx-5">
                        <div className="sx-media">
                          <i className="flaticon-email-2" />
                        </div>
                        <div className="sx-icon-bx-info">
                          <span className="sx-icon-bx-title-info">Contact Mail</span>
                          <a href="mailto:info@infotraceanalytics.com" className="sx-icon-bx-title">
                            info@infotraceanalytics.com
                          </a><br />
                          <span className="sx-icon-bx-title-info">Business Mail</span>
                          <a href="mailto:business@infotraceanalytics.com" className="sx-icon-bx-title">
                            business@infotraceanalytics.com
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 m-b30">
                      <div className="sx-icon-bx-5">
                        <div className="sx-media">
                          <i className="flaticon-map-location" />
                        </div>
                        <div className="sx-icon-bx-info">
                          <span className="sx-icon-bx-title-info">Contact Location</span>
                          <span className="sx-icon-bx-title">69825 Mombasa Road Red Commercial Complex</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 m-b30">
                      <div className="sx-icon-bx-5">
                        <div className="sx-media">
                          <i className="flaticon-clock" />
                        </div>
                        <div className="sx-icon-bx-info">
                          <span className="sx-icon-bx-title-info">Office Time</span>
                          <span className="sx-icon-bx-title">
                            Mon- Fri: 8.00 - 17.00
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="col-lg-4 col-md-12 m-b30">
                <div className="contact-home1-right">
                  <div className="contact-home-1-form sx-bg-light">
                    <h4 className="sx-title">Get In Touch</h4>

                    {/* Status Messages */}
                    {submitStatus && (
                      <div className={`alert ${submitStatus.type === 'success' ? 'alert-success' : 'alert-danger'} m-b20`}>
                        {submitStatus.message}
                      </div>
                    )}

                    <form className="cons-contact-form2 form-transparent" onSubmit={handleSubmit}>
                      {/* Honeypot: keep invisible and out of tab order */}
                      <div style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden' }} aria-hidden="true">
                        <label htmlFor="website">Website</label>
                        <input
                          id="website"
                          type="text"
                          name="website"
                          value={formData.website}
                          onChange={handleInputChange}
                          tabIndex={-1}
                          autoComplete="off"
                        />
                      </div>
                      <div className="input input-animate">
                        <input
                          type="text"
                          name="username"
                          placeholder="Your Name *"
                          value={formData.username}
                          onChange={handleInputChange}
                          disabled={isSubmitting}
                          className={errors.username ? 'error' : ''}
                          required
                        />
                        {errors.username && (
                          <span className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                            {errors.username}
                          </span>
                        )}
                      </div>

                      <div className="input input-animate">
                        <input
                          type="email"
                          name="email"
                          placeholder="Your Email *"
                          value={formData.email}
                          onChange={handleInputChange}
                          disabled={isSubmitting}
                          className={errors.email ? 'error' : ''}
                          required
                        />
                        {errors.email && (
                          <span className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                            {errors.email}
                          </span>
                        )}
                      </div>

                      <div className="input input-animate">
                        <input
                          type="text"
                          name="phone"
                          placeholder="Phone Number"
                          value={formData.phone}
                          onChange={handleInputChange}
                          disabled={isSubmitting}
                        />
                      </div>

                      <div className="input textarea input-animate">
                        <textarea
                          name="message"
                          placeholder="Your Message *"
                          value={formData.message}
                          onChange={handleInputChange}
                          disabled={isSubmitting}
                          className={errors.message ? 'error' : ''}
                          required
                        />
                        {errors.message && (
                          <span className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                            {errors.message}
                          </span>
                        )}
                      </div>

                      <div className="sx-btn-center text-center p-t10">
                        <button
                          type="submit"
                          className="site-button sx-btn-primary icon sx-btn-lg"
                          disabled={isSubmitting}
                        >
                          <i className="fa fa-long-arrow-right" />
                          {isSubmitting ? 'Sending...' : 'Send Message'}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact us END */}
    </>
  );
}

export default ContactUsPage;